import { Page } from "shared/react";
import { type CreatorEntity, type CreatorType, LEADERBOARD_MAX } from "shared/schema";
import { LeaderboardChallengeList } from "../challenge/ChallengeList.js";
import { EntityBackgroundHeader } from "../entity/EntityBackgroundHeader.js";
import { EntityButton } from "../entity/EntityButton.js";
import { USER } from "../util/user.js";

/**
 * Show a list of the challenges that the current user has joined for a given entity (e.g. group).
 * - Shows a `<ChallengeCard>` for each leaderboard along with a big `Show leaderboard` button.
 */
export function LeaderboardsPage({ type, id }: { type: CreatorType; id: string }): React.ReactElement {
	const creator: CreatorEntity = `${type}:${id}`;
	return (
		<Page title="Joined leaderboards">
			<EntityBackgroundHeader entity={creator} mods="pad-3x">
				<div>
					<h1>Joined leaderboards</h1>
				</div>
				<EntityButton entity={creator} mods="pin-left pin-bottom size-small" />
			</EntityBackgroundHeader>
			<section>
				<LeaderboardChallengeList //
					query={{ creator, uid: USER.data.uid, tid: "a", $order: "!updated", $limit: LEADERBOARD_MAX }}
					empty="No joined leaderboards"
				/>
			</section>
		</Page>
	);
}
